import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

import { SpaLoadPeriodDTO } from '@api';

@Pipe({
  name: 'calculateIndexOfTime',
  standalone: false,
})
export class CalculateIndexOfTimePipe implements PipeTransform {
  transform(load: SpaLoadPeriodDTO[] | undefined): number {
    const period = load?.map((load) => load.period);
    return (
      period?.findIndex((timeSlot) => {
        return moment().isSameOrAfter(moment(timeSlot.from)) && moment().isSameOrBefore(moment(timeSlot.to));
      }) ?? -1
    );
  }
}
